import React, { Component } from 'react';
import { SvgIcon as OriginSvgIcon } from '@tinper/next-ui';

require('@tinper/next-ui/lib/wui-svgicon/src/iconfont');

/**
 * @namespace SvgIcon
 */

/**
 * SvgIcon组件的参数描述
 * @memberof SvgIcon
 * @component SvgIcon
 * @property {string} className - 自定义类名
 * @property {string} type  - 图标类型。遵循图标的命名规范
 * @property {ComponentType} component - 控制如何渲染图标，通常是一个渲染根标签为
 * @property {string} fieldid - 组件内元素标识, 推荐自动化测试使用
 */
export default class SvgIcon extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return <OriginSvgIcon {...this.props} />;
    }
}